import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeadFormAndWidgetWrapper from "./component";
import { fetchData } from "../banner-widget/actions";
import { setShowWidget } from "../lead-form/actions";
import { fetchDataSuccess } from "../banner-widget/actions";
import { getRepeatInspectionWidget, resetUserDropData, setSsrStatus } from "../../desktop/user-journey-drop/actions";
import { setUserCarRegistrationNO } from "../car-registration-number/actions";

const mapStateToProps = ({
    user,
    leadData,
    widgetData,
    userDropWidget: {
        data: {isUserDrop, isError, allCardInfo},
        isSSR
    },
    experiments: {
        userDrop: {
            data: userDropExperiment
        }
    },
    user: {userId}
}) => ({
    user,
    leadData,
    widgetData,
    isUserDrop,
    isSSR,
    isError,
    allCardInfo,
    userId,
    userDropExperiment
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchDataConnect: fetchData,
    setShowWidgetConnect: setShowWidget,
    fetchDataSuccessConnect: fetchDataSuccess,
    getRepeatInspectionWidgetConnect: getRepeatInspectionWidget,
    setSsrStatusConnect: setSsrStatus,
    resetUserDropDataConnect: resetUserDropData,
    setUserCarRegistrationNOConnect: setUserCarRegistrationNO
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LeadFormAndWidgetWrapper);
